import { useEffect, useState } from 'react'
import isPlainObject from 'lodash-es/isPlainObject'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { LOCAL_STORAGE_BIRDVIEW_CHART_CONTROLS_KEY } from '../../../../constants/storage'
import { setStorageSerializedItem } from '../../../../utils/storage'
import {
  getBirdviewStorageKey,
  readBirdviewStorageItem,
} from '../../DashboardBirdview.utils.storage'

export function useBirdviewChartControls({ storageScope }) {
  const storageKey = getBirdviewStorageKey(
    LOCAL_STORAGE_BIRDVIEW_CHART_CONTROLS_KEY,
    [storageScope]
  )

  const [chartControls, setChartControls] = useState(
    () => readBirdviewStorageItem(storageKey, isPlainObject) ?? EMPTY_OBJECT
  )

  useEffect(() => {
    setStorageSerializedItem(storageKey, chartControls)
  }, [chartControls, storageKey])

  function handleChangeChartControls(sectionKey, controls) {
    setChartControls(prev => ({
      ...prev,
      [sectionKey]: { ...prev[sectionKey], ...controls },
    }))
  }

  function handleResetChartControls() {
    setChartControls(EMPTY_OBJECT)
  }

  return { chartControls, handleChangeChartControls, handleResetChartControls }
}
